import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchSummaryGraphs, fetchSummaryPdf } from '../../api/summaryApi';
import originalMoment from "moment";
import { extendMoment } from "moment-range";
import downloadFile from '../../helpers/downloadFile';

const moment = extendMoment(originalMoment);

const initialState = {
	groups: [],
	categories: [],
	total: null,
	periodStart: '2025-01-01',
	perioEnd: '2025-01-31',
	loading: false,
	loadingSave: false
}

export const getSummaryGraph = createAsyncThunk(
	'summary/getGraph',
	async (periodChanged = false, thunkAPI) => {
		let start = null;
		let end = null;

		if(!periodChanged){
			start = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
			end = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
		}else{
			const state = thunkAPI.getState().summary;
			start = state.periodStart;
			end = state.perioEnd;
		}
		
		const data = await fetchSummaryGraphs({start, end});
		return {...data, start, end};
	}
)

export const getSummaryPdf = createAsyncThunk(
	'summary/getPdf',
	async (_, thunkAPI) => {
		const state = thunkAPI.getState().summary;
		const {groups, categories, total, periodStart, perioEnd} = state		
		const resp = await fetchSummaryPdf({groups, categories, total, periodStart, perioEnd});

		// Convertir el archivo base64 a Blob
		const byteCharacters = atob(resp);
		const byteNumbers = new Array(byteCharacters.length);
		for (let i = 0; i < byteCharacters.length; i++) {
			byteNumbers[i] = byteCharacters.charCodeAt(i);
		}
		const byteArray = new Uint8Array(byteNumbers);
		const file = new Blob([byteArray], { type: 'application/pdf' });

		const fiename = `Reporte GRC ${moment().format('YYYY-MM-DD')}.pdf`

		downloadFile(file, fiename);
})


const summarySlice = createSlice({
	name: "summarySlice",
	initialState,
	reducers: {
		handleSelectDate: (state, action) => {
			const { start, end } = action.payload
			if (start !== undefined) {
				if (moment(start).isBefore(state.perioEnd)) state.periodStart = start;
			}
			if (end !== undefined) {
				if (moment(end).isAfter(state.periodStart)) state.perioEnd = end;
			}
		},
		handleSelectPeriod: (state, action) => {
			const { start, end } = action.payload
			state.periodStart = start;
			state.perioEnd = end;
			console.log(start, end)
		},
		setPeriodLabel: (state, action) => {
			state.periodLabel = action.payload
		}
	},
	extraReducers: builder => {
		builder
			.addCase(getSummaryGraph.pending, (state) => {
				state.groups = []
				state.categories = []
				state.total = null
				state.loading = true
			})
			.addCase(getSummaryGraph.fulfilled, (state, action) => {
				state.groups = action.payload.groups
				state.categories = action.payload.categories
				state.total = action.payload.total
				state.loading = false
				state.periodStart = action.payload.start;
				state.perioEnd = action.payload.end;
			})
			.addCase(getSummaryGraph.rejected, (state, action) => {
				state.groups = []
				state.categories = []
				state.total = null
				state.loading = false
			})
	}
})

export const summarySelector = state => state.summary;
export const { handleSelectDate, handleSelectPeriod, setPeriodLabel } = summarySlice.actions
export default summarySlice.reducer;